// extracted by mini-css-extract-plugin
export default {"thumb":"CustomThumbComponent_thumb__60B8j"};